export const subscribeForm = () => {
  $('.ft-form').validate({
    submitHandler: function (form) {
      $('.subscribe-block').addClass('active')

      setTimeout(function () {
        $('.subscribe-block form').hide()
        $('.subscribe-block').html(`
          <div class="subscribe__text">
            Subscription Confirmed!
            </div>
        `).removeClass('active')


      }, 1000);

    },
    success: () => {
    },
    errorPlacement: function (error, element) {
      const _element = $(element);
      if (_element.hasClass('error')) {
        _element.closest('div[class^="form-holder"]').addClass('has-error').removeClass('accept');
        _element.addClass('error');
      } else {
        _element.closest('div[class^="form-holder"]').removeClass('has-error').addClass('accept');
        _element.removeClass('error');
      }
    },
    rules: {
      email: {
        required: true,
        email: true
      },

    },
  });
}
